module.exports = __webpack_public_path__ + "static/sggs-4a705327a862c5910f2b826a08772b75.png";